// gender.js (em migração do global.js)
// Constantes relacionadas a sexo e identidade de gênero

export const GENDER_OPTIONS = [
    { value: 'M', label: 'Masculino' },
    { value: 'F', label: 'Feminino' },
    { value: 'O', label: 'Outro' },
    { value: 'U', label: 'Não Informado' }
];

export const GENDER_LABELS = {
    'M': 'Masculino',
    'F': 'Feminino',
    'O': 'Outro',
    'U': 'Não Informado'
};
